import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setActiveBudgetTab } from "../../../redux/slices/loginSlice";
import { useHistory } from "react-router-dom";
import "../BudgetMain.css";
import creditCard from "../../../assets/images/creditcard.png";
import savingImg from "../../../assets/images/bank.png";
import uncategorizedImg from "../../../assets/images/adjustable_dollar2.png";
import currencyImg from "../../../assets/images/currency3.png";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import { MODULE_API } from "../../../apis";

const BudgetAccountsSkeleton = () => (
  <div className="budget-accounts-skeleton" aria-hidden="true">
    {[0, 1, 2, 3].map((item) => (
      <div className="budget-accounts-skeleton__row" key={item}>
        <div className="budget-accounts-skeleton__icon" />
        <div className="budget-accounts-skeleton__content">
          <div className="budget-accounts-skeleton__line budget-accounts-skeleton__line--title" />
          <div className="budget-accounts-skeleton__line budget-accounts-skeleton__line--amount" />
        </div>
      </div>
    ))}
  </div>
);

export const BudgetTransaction = ({ budgetTransactions, clientBanks, isLoading = false }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [banksCredit, setBanksCredit] = useState(0);

  const getCreditSum = async () => {
    try {
      let data = await MODULE_API.fetchLiabilitySum("Credit");
      if (data && data.sum) {
        setBanksCredit(data.sum);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCreditSum();
  }, []);

  const createFinancialSummary = (
    budgetTransactions, 
    clientBanks, 
  ) => {
    // Helper function to create combos
    const createCombos = (data = []) => {
      return data.map(item => ({
        combo: `${item.accountName}_${item.bankName}_${item.accountNumber}`,
        balance: parseFloat(item.balance) || 0
      }));
    };
  
    // Create combos for each data category
    const checkingCombos = createCombos(budgetTransactions.checkingSavingData);
    const creditCardCombos = createCombos(budgetTransactions.creditData);
    const cashCombos = createCombos(budgetTransactions.cashData);
    const uncategorizedCombos = createCombos(budgetTransactions.nullCategoryData);
  
    const clientBankCombos = createCombos(clientBanks);
  
    // Helper function to combine balances
    const combineBalances = (combos) => {
      return combos.reduce((acc, { combo, balance }) => {
        const clientBankEntry = clientBankCombos && combo && clientBankCombos.find(bank => bank.combo === combo);
        const clientBalance = clientBankEntry && clientBankEntry.balance || 0;
    
        acc[combo] = {
          checkingBalance: balance,
          clientBankBalance: clientBalance,
          totalBalance: balance + clientBalance,
        };
        return acc;
      }, {});
    };
    // Combine balances for each category
    const combinedChecking = checkingCombos && combineBalances(checkingCombos);
    const combinedCreditCards = creditCardCombos && combineBalances(creditCardCombos);
    const combinedUncategorized = uncategorizedCombos && combineBalances(uncategorizedCombos);
    
    const calculateTotal = (combinedBalances) =>
      Object.values(combinedBalances).reduce(
        (sum, { totalBalance }) => sum + totalBalance, 0
      );
      
      const checkingSavingTotal = calculateTotal(combinedChecking);
      const creditTotal = calculateTotal(combinedCreditCards);
      const nullCategoryTotal = calculateTotal(combinedUncategorized);
      const cashTotal = budgetTransactions.cashData && budgetTransactions.cashData.reduce(
        (total, item) => total + (parseFloat(item.amount) || 0),
        0
      ) || 0;
    // Return result array
    return [
      {
        bankName: "Checking and Saving",
        total: checkingSavingTotal,
        priority: 1,
        image: savingImg
      },
      {
        bankName: "Credit Cards",
        total: banksCredit || creditTotal,
        priority: 2,
        image: creditCard
      },
      {
        bankName: "Cash",
        total: cashTotal,
        image: currencyImg,
        priority: 3,
      },
      {
        bankName: "Uncategorized",
        total: nullCategoryTotal,
        priority: 4,
        image: uncategorizedImg
      }
    ];
  };
  
  const financialAccess =
  localStorage.getItem("financialAccess") != "undefined" &&
  JSON.parse(localStorage.getItem("financialAccess") || null);
  const resultArray = budgetTransactions && clientBanks && createFinancialSummary(budgetTransactions, clientBanks);
  return (
    <div style={{ width: "100%" }}>
      {" "}
      <div
        className="BudgetMainReport2"
        style={{
          position: "relative",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}>
        <div className="reportCard3" style={{ width: "100%" }}>
          <div
            className="budget-home-icon-container"
            style={{ justifyContent: "space-between", width: "100%" }}>
            <div>
              <h3
                className="Reportheading"
                style={{ fontSize: "16px", fontWeight: "600", color: "black" }}>
                Accounts
              </h3>
            </div>
            {(!financialAccess || !financialAccess.hideTransactions) && (
            <button
              className="addbuttonassets"
              onClick={() => {
                dispatch(setActiveBudgetTab(0));
                history.push("/budget/add/transaction");
              }}>
              {" "}
              See All Transactions
            </button>
            )}
          </div>
          <div className="reprotcardRow">
            <div className="listingContainerTransactions">
              <React.Fragment>
                {isLoading ? (
                  <React.Fragment>
                    <BudgetAccountsSkeleton />
                  </React.Fragment>
                ) : resultArray && resultArray.length > 0 ? (
                  resultArray.map((item, index) => (
                    <div
                      key={index}
                      className="list-row-transaction"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        console.log("item.prioirty", item.priority);
                        dispatch(setActiveBudgetTab(item.priority));
                        history.push("/budget/add/transaction");
                      }}>
                      <div className="transactionLogo">
                        <img
                          src={item.image}
                          height={"32px"}
                          width={"32px"}
                          alt={"new"}
                        />
                      </div>
                      <div className="list-row-transaction-inner">
                        <div className="listname-dark">
                          <div>{item.bankName}</div>
                          <div style={{ color: "#030229", fontWeight: "400" }}>
                            {item.total
                              ? item.total &&
                                `$${item.total
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` // If bankName matches, show banksCredit
                              : `$${0
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
                          </div>
                        </div>
                        {item.bankName === "Cash" && (
                          <div
                            onClick={() => {
                              console.log("recode");
                            }}
                            style={{
                              cursor: "pointer",
                              marginRight: "1rem",
                              padding: "0px 16px",
                              width: "5px",
                            }}>
                            <img
                              src={menuIcon}
                              alt="menuIcon"
                              height={18}
                              width={4}></img>
                          </div>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="nodata">No Data to Show</div>
                )}
              </React.Fragment>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
